module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3tQMc1OER6MQXkbBNuzdC3-05122be3248ef87b45f9bec0cff508f2.jpg";